import { useState,useEffect } from "react";
import Calcolatrice from "./calcolatrice";
import Container from '@mui/material/Container';



const testoInvertiCalcolo = (en) => {

    if(en) return ("Enter the combination of single chainring and sprockets you want and the calculator will show you the distance per stroke for each relationship in the function 1:1 than in that 1:1.25")

    return ("Inserisci la combinazione di monocorona e pignoni che vuoi e la calcolatrice ti indicherà gli sviluppi lineari per ogni rapporto sia nella funzione 1:1 che in quella 1:1,25")
}

const testoOriginale = (en, chunk) => {


    switch (chunk) {
        case 1:
            if(!en) return "Inserisci la tua attuale combinazione di monocorona e pignoni." 
            else return "Enter your current single chainring and sprocket combination."
        case 2:
            if(!en) return "La calcolatrice ti calcolerà gli sviluppi lineari per ogni rapporto." 
            else return "The calculator will give you the linear distance per stroke for each relationship."
        case 3:
            if(!en) return "Ti indicherà anche quale monocorona dovresti installare nel Binary per mantenere i tuoi attuali sviluppi nella sua funzione accelerata (1:1,25) e dandoti tutti quelli relativi al monocorona più piccolo installato nella sua funzione a rapporto 1:1"
            else return "It will also tell you which single chainring you should install in the Binary to keep Your current developments in its accelerated function (1:1,25) and giving you all those relating to the smallest chainring installed in its function at a ratio of 1:1"
            
        default:
            return "";
    }


}



const StartScreen = (props) => {

    const [en,setEn] = useState(false)
    const [invertiCalcolo,setInvertiCalcolo] = useState(false)
    const [calcolatriceAperta,setCalcolatriceAperta] = useState(false)

    useEffect(() => {

        let url = new URL(window.location.href);
        let pat = url.pathname.split('/')
    
        if(pat && pat.length > 2 && pat[1] === 'en') {
          setEn(true)
        }
        else  {
            setEn(false)
        }
    
    
      },[])


    return (
    <div style={{display: 'flex', flexDirection: 'column', marginBottom: '50px'}}>
        <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', flexWrap: 'wrap'}}>
            <div style={{
                         width: '210px',
                         padding: '20px 30px', 
                         borderRadius: '10px',
                         color: (!calcolatriceAperta) ? 'black' : (!invertiCalcolo) ? 'white' : 'black',
                         backgroundColor: (!calcolatriceAperta) ? '#e8e8e8' : (!invertiCalcolo) ? '#cf2e2e' : '#e8e8e8',
                         fontWeight: 'bold', 
                         marginRight: '20px', cursor: 'pointer',
                         boxShadow: '0px 5px 10px 0px rgba(0,0,0,0.3)',
                         marginBottom: '20px'
                         }} onClick={() => {setInvertiCalcolo(false); setCalcolatriceAperta(true)}}>
                         {en ? "CALC. WITH YOUR CRANKSET" : "CALCOLA CON I TUOI DATI"}
                         </div>
            <div style={{
                         width: '210px',
                         padding: '20px 30px', 
                         borderRadius: '10px',
                         color: (!calcolatriceAperta) ? 'black' : (invertiCalcolo) ? 'white' : 'black',
                         backgroundColor: (!calcolatriceAperta) ? '#e8e8e8' : (invertiCalcolo) ? '#cf2e2e' : '#e8e8e8',fontWeight: 'bold', cursor: 'pointer',
                         boxShadow: '0px 5px 10px 0px rgba(0,0,0,0.3)',
                         marginBottom: '20px'
                         

                         }} onClick={() => {setInvertiCalcolo(true); setCalcolatriceAperta(true)}}>
                         {en ? "CALC. WITH BINARY" : "CALCOLA CON BINARY"}
                         </div>
        </div>
        {calcolatriceAperta && <Container maxWidth="lg">
            <div style={{width: '100%', textAlign: 'left', marginTop: '20px', fontSize: '14pt'}}>
                {invertiCalcolo && testoInvertiCalcolo(en)}                 
                {!invertiCalcolo && <div style={{marginBottom: '10px'}}>{testoOriginale(en,1)}</div>}                 
                {!invertiCalcolo && <div style={{marginBottom: '10px'}}>{testoOriginale(en,2)}</div>}                 
                {!invertiCalcolo && <div>{testoOriginale(en,3)}</div>}                 
            </div>
        </Container>}
        {calcolatriceAperta && <Calcolatrice en={en} invertiCalcolo={invertiCalcolo}/>}
    </div>)
    
}

export default StartScreen